import { AlertTriangle, CheckCircle2, MinusCircle, XCircle } from 'lucide-react';
import {
  describeOutcome,
  type HubspotEntityStatus,
  type HubspotSyncJobStatus,
} from '@/lib/hubspot-sync';

const ICON: Record<HubspotEntityStatus, { icon: typeof CheckCircle2; className: string }> = {
  SUCCESS: { icon: CheckCircle2, className: 'text-green-600' },
  PARTIAL: { icon: AlertTriangle, className: 'text-amber-600' },
  FAILED: { icon: XCircle, className: 'text-red-600' },
  SKIPPED: { icon: MinusCircle, className: 'text-muted-foreground' },
};

/** «Empresas: 2 registros actualizados / Contactos: falló (…) / Oportunidades: …». */
export function HubspotSyncResultList({ status }: { status: HubspotSyncJobStatus }) {
  if (!status.outcomes) {
    return status.error ? <p className="pt-2 text-xs text-red-600">{status.error}</p> : null;
  }
  return (
    <ul className="space-y-1 pt-2 text-xs" aria-label="Resultado de la última importación">
      {status.outcomes.map((o) => {
        const { icon: Icon, className } = ICON[o.status];
        return (
          <li key={o.entity} className="flex items-center gap-1.5">
            <Icon className={`h-3.5 w-3.5 ${className}`} aria-hidden />
            <span>{describeOutcome(o)}</span>
          </li>
        );
      })}
    </ul>
  );
}
